import { NavItem } from '../../Actions/NavItems/NavItem';
import styles from './styles.module.scss';

export const SecondNavRowItem = (props: Parameters<typeof NavItem>[0]) => {
  return <NavItem className={styles.secondRowNavItem} {...props} />;
};
